export default {
    crop: {
        title: "Ernte",
        cropSize: "Bildgröße",
        zoom: "Zoom",
        custom: 'Der Brauch',
        post: 'Post',
        square: 'Quadrat',
        landscape: 'Landschaft',
        story: 'Geschichte',
        portrait: 'Porträt',
        carousel: 'Karussell',
        commonAspectRatio: 'Gängiges Bildseitenverhältnis',
    },
};
